module.exports = __webpack_public_path__ + "static/media/iotx.2fb42174.svg";